"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatManEducatorStrategy = void 0;
const base_user_app_1 = require("./util/base-user-app");
const MatManEducatorStrategy = () => {
    return (0, base_user_app_1.BaseUserAppStrategy)({ path: 'aztapp-login' });
};
exports.MatManEducatorStrategy = MatManEducatorStrategy;
